import type { ComputedRef, Ref } from 'vue'
import { computed, onUnmounted, ref, watch } from 'vue'

const lockCount = ref(0)
let previousBodyOverflow = ''

export function useBodyScrollLock(locked: ComputedRef<boolean> | Ref<boolean>) {
  let ownsLock = false

  function sync(shouldLock: boolean) {
    if (!import.meta.client) return
    if (shouldLock && !ownsLock) {
      if (lockCount.value === 0) {
        previousBodyOverflow = document.body.style.overflow
        document.body.style.overflow = 'hidden'
      }
      lockCount.value += 1
      ownsLock = true
      return
    }

    if (!shouldLock && ownsLock) {
      lockCount.value = Math.max(0, lockCount.value - 1)
      ownsLock = false
      if (lockCount.value === 0) {
        document.body.style.overflow = previousBodyOverflow
        previousBodyOverflow = ''
      }
    }
  }

  watch(locked, sync, { immediate: true })
  onUnmounted(() => sync(false))
}

// Every current overlay (FX/Debug/Track Mute/Export Stems/Loading) already
// calls useBodyScrollLock while open, so its lock count doubles as "is some
// modal covering the screen right now" — used to stop background hotkey
// handlers (pad preview, etc.) from firing at whatever's still listening
// on window underneath the overlay.
export function useAnyModalOpen(): ComputedRef<boolean> {
  return computed(() => lockCount.value > 0)
}
